import { useEffect, useState } from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

// 맨 위/맨 아래로 즉시 이동하는 플로팅 내비(2026-07-18 요청) — 표가 길어서 스크롤이
// 깊어지는 대시보드 특성상 자주 필요하다. 페이지가 짧거나 아직 맨 위면 숨겨서
// 필요할 때만 나타나는 미니멀 컨트롤로 둔다.
export default function ScrollNav() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      setVisible(scrollable > 600 && window.scrollY > 240);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  if (!visible) return null;

  const btnCls =
    "flex h-9 w-9 items-center justify-center rounded-full border border-ink-200 bg-white/95 text-ink-500 shadow-md backdrop-blur transition-colors hover:text-ink-900";

  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col gap-1.5 sm:right-6">
      <button
        type="button"
        aria-label="맨 위로"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={btnCls}
      >
        <ArrowUp className="h-4 w-4" />
      </button>
      <button
        type="button"
        aria-label="맨 아래로"
        onClick={() => window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" })}
        className={btnCls}
      >
        <ArrowDown className="h-4 w-4" />
      </button>
    </div>
  );
}
